import React, {
  Fragment,
  useCallback,
  useState,
  useMemo,
  useRef,
  useEffect,
} from "react";
import { Link } from "react-router-dom";
import { Card, Button, Form } from "react-bootstrap";
import {
  useTable,
  useGlobalFilter,
  useFilters,
  usePagination,
} from "react-table";
import { COLUMNSCOMPRA } from "./Columns";
import { GlobalFilter } from "./GlobalFilter";
import "./filtering.css";
import { getDetalleVentaByDate } from "../../../Api/facturacion";
import { getAdminCredentials, getAdminById } from "../../../Api/AdminApi";
import { JsonToExcel } from "react-json-to-excel";
import { TailSpin } from "react-loader-spinner";
import { formatNumber } from "../../../Utils/formatNumber"; // ✅ Import util

const Listadeventas = () => {
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [userData, setUserData] = useState(null);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const columns = useMemo(() => COLUMNSCOMPRA, []);

  // 🔹 Cargar datos del usuario logueado
  useEffect(() => {
    const loadUser = async () => {
      try {
        const resultUser = await getAdminCredentials();
        const datauser = await getAdminById(resultUser.IdUsuario);
        setUserData(datauser[0]);
      } catch (err) {
        console.error("Error al obtener usuario:", err);
      }
    };
    loadUser();
  }, []);

  // 🔹 Buscar ventas por fechas
  const BuscarPorFechas = useCallback(async () => {
    if (!fechaInicio || !fechaFin) {
      alert("Seleccione una fecha de inicio y fin.");
      return;
    }

    try {
      setLoading(true);
      const result = await getDetalleVentaByDate(fechaInicio, fechaFin);
      console.log(result);
      let resultfiltro = result || [];

      // 🔸 Ocultar montos si el usuario no tiene permiso
      if (userData && userData.ventas_montos === "false") {
        resultfiltro = resultfiltro.map((item) => ({
          ...item,
          total: "",
          precio: "",
        }));
      }

      setdata(resultfiltro);
    } catch (err) {
      console.error(err);
      alert("Error al obtener los datos filtrados.");
    } finally {
      setLoading(false);
    }
  }, [fechaInicio, fechaFin, userData]);

  // 🔹 Configuración de tabla
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;

  const { globalFilter, pageIndex } = state;
  const tableRef = useRef(null);

  return (
    <Fragment>
      <div className="col-md-12 mb-3">
        <Card>
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center">
              <Card.Title>🧾 Detalle de Ventas</Card.Title>
              <JsonToExcel
                title="Descargar Excel"
                data={data}
                fileName="Ventas"
                btnClassName="btn btn-success btn-sm"
              />
            </div>
          </Card.Body>
        </Card>
      </div>

      <div className="col-md-12">
        <Card>
          <Card.Body>
            {/* 🔹 FILTRO DE FECHAS */}
            <div className="row mb-3">
              <div className="col-md-3">
                <Form.Label>Fecha inicio</Form.Label>
                <Form.Control
                  type="date"
                  value={fechaInicio}
                  onChange={(e) => setFechaInicio(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <Form.Label>Fecha fin</Form.Label>
                <Form.Control
                  type="date"
                  value={fechaFin}
                  onChange={(e) => setFechaFin(e.target.value)}
                />
              </div>
              <div className="col-md-2 d-flex align-items-end">
                <Button
                  variant="primary"
                  onClick={BuscarPorFechas}
                  className="w-100"
                  disabled={loading}
                >
                  Buscar
                </Button>
              </div>
            </div>

            {/* 🔹 Filtro global */}
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />

            {loading && (
              <div className="text-center my-3">
                <TailSpin height="40" width="40" color="black" />
              </div>
            )}

            {/* 🔹 TABLA DE RESULTADOS */}
            <div className="table-responsive">
              <table
                {...getTableProps()}
                className="table table-striped table-bordered"
                ref={tableRef}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th key={column.id} {...column.getHeaderProps()}>
                          {column.render("Header")}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.length > 0 ? (
                    page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr key={row.id} {...row.getRowProps()}>
                          {row.cells.map((cell) => {
                            const col = cell.column.id;
                            const value = cell.value;

                            // 🔹 Formatear columnas numéricas
                            const formattedValue = ["precio", "total", "cantidad"].includes(col)
                              ? formatNumber(value)
                              : value;

                            return (
                              <td key={col} {...cell.getCellProps()}>
                                <Link to={`/FichaFactura/${row.values.idFactura}`}>
                                  {formattedValue}
                                </Link>
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={columns.length} className="text-center">
                        {loading
                          ? "Cargando datos..."
                          : "No hay resultados para el rango seleccionado."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* 🔹 PAGINACIÓN */}
            {pageOptions.length > 1 && (
              <>
                <div className="d-flex justify-content-between mt-3">
                  <span>
                    Página <strong>{pageIndex + 1}</strong> de{" "}
                    {pageOptions.length}
                  </span>

                  <span>
                    Ir a página:{" "}
                    <input
                      type="number"
                      min="1"
                      style={{ width: "80px" }}
                      defaultValue={pageIndex + 1}
                      onChange={(e) => {
                        const pageNumber = e.target.value
                          ? Number(e.target.value) - 1
                          : 0;
                        gotoPage(pageNumber);
                      }}
                    />
                  </span>
                </div>

                <div className="text-center mt-3">
                  <div className="btn-group">
                    <Button
                      variant="outline-primary"
                      onClick={() => gotoPage(0)}
                      disabled={!canPreviousPage}
                    >
                      {"<<"}
                    </Button>
                    <Button
                      variant="outline-primary"
                      onClick={() => previousPage()}
                      disabled={!canPreviousPage}
                    >
                      Anterior
                    </Button>
                    <Button
                      variant="outline-primary"
                      onClick={() => nextPage()}
                      disabled={!canNextPage}
                    >
                      Siguiente
                    </Button>
                    <Button
                      variant="outline-primary"
                      onClick={() => gotoPage(pageCount - 1)}
                      disabled={!canNextPage}
                    >
                      {">>"}
                    </Button>
                  </div>
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      </div>
    </Fragment>
  );
};

export default Listadeventas;
